import '../styles/Blog.scss';
import Header from '../components/Header';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import DOMPurify from 'dompurify';

const sampleBlog1 = `${process.env.REACT_APP_S3_URL}sampleBlog1.png`;
const sampleBlog2 = `${process.env.REACT_APP_S3_URL}sampleBlog2.png`;
const sampleBlog3 = `${process.env.REACT_APP_S3_URL}sampleBlog3.png`;
const sampleBlog4 = `${process.env.REACT_APP_S3_URL}sampleBlog4.png`;
const sampleBlog = `${process.env.REACT_APP_S3_URL}sampleBlog5.png`;
const LeftArrowBlack = `${process.env.REACT_APP_S3_URL}LeftArrowBlack.png`;
const RightArrowBlack = `${process.env.REACT_APP_S3_URL}RightArrowPink.svg`;
const CrossUpArrowBlack = `${process.env.REACT_APP_S3_URL}rightSlantblack.png`;
const CrossUpArrow = `${process.env.REACT_APP_S3_URL}rightSlantblack.svg`;
const LeftArrowInActive = `${process.env.REACT_APP_S3_URL}LeftArrowBlack.svg`;
const LeftArrowActive = `${process.env.REACT_APP_S3_URL}LeftArrowPink.svg`;
const RightArrowInActive = `${process.env.REACT_APP_S3_URL}RightArrowBlack.svg`;
const RightArrowActive = `${process.env.REACT_APP_S3_URL}RightArrowPink.svg`;
interface BlogPost {
    blogId: string;
    postedOn: string;
    header: string;
    description: string;
    thumbnail: string;
    mainTitleKey: string;
}

const Blogs = () => {
    const navigate = useNavigate();
    const [blogPosts, setBlogPosts] = useState<BlogPost[]>([]);
    const [newposts, setNewPosts] = useState<BlogPost[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);
        axios.get(process.env.REACT_APP_BACKEND_URL + '/api/v1/blogs')
            .then(response => {
                console.log(response.data);
                setBlogPosts(response.data);
                setNewPosts(response.data.slice(1, 5));
                setIsLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the blog posts!', error);
                setError('Failed to load blogs. Please try again later.');
                setIsLoading(false);
            });
    }, []);

    const itemsPerPage = 6; // Number of jobs per page
    const totalPages = Math.ceil(blogPosts.length / itemsPerPage);
    const [currentPage, setCurrentPage] = useState(1);
    // Get jobs for the current page
    const currentJobs = blogPosts.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers for navigation
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToBlog = (blogId: string) => {
        navigate('/Blogs/'+ blogId);
    }

    return (
        <div>
            {isLoading ? (
                <div className="loading-state">Loading case studies...</div>
            ) : error ? (
                <div className="error-state">
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()}>Try Again</button>
                </div>
            ) : (
            <div className="blogposts-container">
                <div className='blog-herosection'>
                    <div className='left'>
                        <div onClick={() => {goToBlog(blogPosts[0]?. mainTitleKey)}} className="post-card">
                            <img src={blogPosts[0]?.thumbnail} alt='' className="post-image" style={{height:340}}/>
                            <div className="post-content">
                            {/* <p className="post-date">{blogPosts[0]?.postedOn}</p> */}
                            <div style={{display:'flex', flexDirection: 'row', justifyContent:'space-between', alignItems: 'center'}}>
                                <div>
                                    <h2 style={{width:'85%'}} className="post-title">{blogPosts[0]?.header}
                                    </h2>
                                </div>
                                <div className="arrow-icon-blog">
                                    <img src={CrossUpArrow} alt='Arrow' />
                                </div>
                            </div>
                            <div className="post-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogPosts[0]?.description || '') }} />
                            </div> 
                        </div>
                    </div>
                    <div className='right'>
                        <div style={{ paddingBottom: 8}}>
                            <span
                            style={{
                                background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text', // For Firefox
                                color: 'transparent',
                              }}
                            className='post-heading'>New Posts</span>
                        </div>
                        {
                        newposts.map((post, index) => (
                            <div onClick={() => {goToBlog(post?. mainTitleKey)}} className="post-content-new">
                                {/* <p className="post-date">{post?.postedOn}</p> */}
                            <div style={{display:'flex', flexDirection: 'row', justifyContent:'space-between', alignItems: 'center'}}>
                                <div>
                                    <h2 style={{width:'85%'}} className="post-title-new">{post?.header}
                                    </h2>
                                </div>
                                <div className="arrow-icon-mobile">
                                    <img style={{paddingRight: 20}} src={CrossUpArrowBlack} alt='Arrow' />
                                </div>
                            </div>
                            {
                                index !== newposts.length - 1
                                ? 
                                <hr style={{marginBottom:0, borderColor: '#1416171A', borderWidth: '1px' }}></hr>
                                : ''
                            }
                        </div>
                        ))}
                    </div>
                </div>
                <div className="header-section-blog">
                    <div>
                        <h1 className="title">
                        All <span className="highlight">Blogposts</span>
                        </h1>
                    </div>
                    <div className="pagination-section-blog">
                        <img
                            style={{ cursor: 'pointer'}}
                            src={currentPage === 1 ? LeftArrowInActive : LeftArrowActive}
                            alt="Left Arrow"
                            onClick={handlePreviousPage}
                        />
                        <span className="page-indicator">{currentPage}/{totalPages}</span>
                        <img
                            style={{ cursor: 'pointer' }}
                            src={currentPage === totalPages ? RightArrowInActive : RightArrowActive}
                            alt="Right Arrow"
                            onClick={handleNextPage}
                        />
                    </div>
                </div>
                
                <div className="posts-section">
                    {currentJobs.map((post, index) => (
                    <div
                    onClick={() => {goToBlog(post?. mainTitleKey)}}
                    className="post-card" key={index}>
                        <img src={post?.thumbnail} alt={post?.header} className="post-image" />
                        <div className="post-content">
                        {/* <p className="post-date">{post?.postedOn}</p> */}
                        <div style={{display:'flex', flexDirection: 'row', justifyContent:'space-between', alignItems: 'center'}}>
                            <div>
                                <h2 style={{width:'85%'}} className="post-title">{post?.header}
                                </h2>
                            </div>
                            <div className="arrow-icon-blog">
                                <img src={CrossUpArrow} alt='Arrow' />
                            </div>
                        </div>
                        <div className="post-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.description) }} />
                        </div> 
                    </div>
                    ))}
                </div>
                <div className="pagination-section-blog-mobile">
                    <img
                        style={{ cursor: 'pointer'}}
                        src={currentPage === 1 ? LeftArrowInActive : LeftArrowActive}
                        alt="Left Arrow"
                        onClick={handlePreviousPage}
                    />
                    <span className="page-indicator">{currentPage}/{totalPages}</span>
                    <img
                        style={{ cursor: 'pointer'}}
                        src={currentPage === totalPages ? RightArrowInActive : RightArrowActive}
                        alt="Right Arrow"
                        onClick={handleNextPage}
                    />
                </div>
            </div>
            )}
        </div>
    )
}

export default Blogs;
